import heroConsultationDesktop from './assets/hero/consultations-hero.webp';
import heroConsultationMobile from './assets/hero/hero_consultation_v3_mobile.webp';
import heroProductsDesktop from './assets/hero/hero_products_v2_desktop.webp';
import heroProductsMobile from './assets/hero/hero_products_v2_mobile.webp';

const LOGO_URL_FROM_SUPABASE = "/astroji-logo.webp";
const FOOTER_LOGO_URL_FROM_SUPABASE = "/logo-light.svg";

export const content = {
  logoUrl: LOGO_URL_FROM_SUPABASE,
  footerLogoUrl: FOOTER_LOGO_URL_FROM_SUPABASE,

  navbar: {
    items: [
      { type: 'link', text: 'All Products', href: '/products' },
      { type: 'link', text: 'Guides', href: '/blog' },
      { type: 'dynamic', text: 'Categories', key: 'categories' },
      { type: 'dynamic', text: 'By Purpose', key: 'purposes' },
      {
        type: 'dropdown',
        text: 'Support',
        sublinks: [
          { text: 'Track Order', href: '/dashboard', isExternal: false },
          { text: 'Product Usage', href: '/product-usage' },
          { text: 'FAQs', href: '/faq' },
          { text: 'Contact Us', href: '/contact', isExternal: false },
        ],
      },
    ],
    cta: {
      text: 'Talk to Astrologer',
      href: '/consultations',
    },
  },
  trustBadges: [
    { title: 'Lab Tested', subtitle: '100% Certified', icon: 'Flask' },
    { title: 'Vedic Rituals', subtitle: 'Energized Products', icon: 'Sparkles' },
    { title: 'Secure Pay', subtitle: 'Safe Checkout', icon: 'ShieldCheckmark' },
    { title: 'Fast Shipping', subtitle: 'India-wide Delivery', icon: 'Rocket' },
  ],
  staticHero: {
    imageUrl: "URL_FOR_HIGH_RES_HERO_IMAGE.webp",
    title: "Handpicked gemstones & ritual remedies for wealth, health & protection — ethically sourced.",
    subtitle: "Authentic stones, lab-certified where applicable, fast India-wide delivery.",
    primaryCta: {
      text: "Shop Gemstones",
      href: "/category/gemstones",
    },
    secondaryCta: {
      text: "Book Consultation",
      href: "/consultation",
    },
  },

  homePage: {
    hero: {
      title: "Navigate Your Destiny.",
      subtitle: "Your one-stop solution for authentic astrological consultations, healing sessions, and occult products. Discover clarity and purpose with Astroji.",
      ctaButton: "Explore Our Services",
    },
    heroCarousel: [
      {
        desktopImageUrl: heroConsultationDesktop,
        mobileImageUrl: heroConsultationMobile,
        title: "Struggling with Career, Love or Health?",
        subtitle: "India's most trusted astrologers are ready to guide you. Get instant answers and life-changing solutions!",
        buttonText: "Talk to Astrologer",
        link: "/consultations",
      },
      {
        desktopImageUrl: heroProductsDesktop,
        mobileImageUrl: heroProductsMobile,
        title: "Attract Wealth, Health & Happiness",
        subtitle: "100% authentic Rudraksha, powerful Gemstones & sacred Yantras. Trusted by lakhs of Indians!",
        buttonText: "Explore Products",
        link: "/products",
      },
    ],
  },

  testimonials: {
    placeholderImageUrl: "https://frwfsybeezicmriyttmf.supabase.co/storage/v1/object/public/astroji-01/testimonial-placeholder.png",
  },

  footer: {
    boldTagline: "Your Spiritual Companion ✨",
    tagline: "Your Spiritual Companion ✨",
    copyrightText: `© ${new Date().getFullYear()} Astroji. All Rights Reserved.`,
    links: [
      { text: 'Privacy Policy', href: '/privacy-policy' },
      { text: 'Terms of Service', href: '/terms-of-service' },
      { text: 'Refund Policy', href: '/refund-policy' },
      { text: 'Shipping Policy', href: '/shipping-policy' },
      { text: 'Guides', href: '/blog' },
      { text: 'FAQs', href: '/faq' }
    ]
  },
} as const;

export const CATEGORIES = [
  { id: 1, name: "rudraksha", tag: "rudraksha", imageUrl: "https://getexpontential.com/files/1761766265090-rudraksha.png" },
  { id: 8, name: "idols", tag: "idols", imageUrl: "https://getexpontential.com/files/1761766128204-idols.png" },
  { id: 8, name: "pyrite", tag: "pyrite", imageUrl: "https://getexpontential.com/files/1768130389832-GROUP%20ADS%20%282%29.png" },
  { id: 2, name: "bracelets", tag: "bracelets", imageUrl: "https://getexpontential.com/files/1761766089328-bracelets.png" },
  { id: 4, name: "pendants", tag: "pendants", imageUrl: "https://getexpontential.com/files/1761766240309-pendants.png" },
  { id: 3, name: "stones", tag: "stones", imageUrl: "https://getexpontential.com/files/1761766290943-stones.png" },
  { id: 6, name: "trees", tag: "trees", imageUrl: "https://getexpontential.com/files/1761766323259-trees.png" },
  // { id: 7, name: "books", tag: "books", imageUrl: "https://getexpontential.com/files/1761766048578-books.png" },
  { id: 5, name: "kits", tag: "kits", imageUrl: "https://getexpontential.com/files/1761766202224-kits.png" },
] as const;

export const PURPOSES = [
  { id: 1, name: "Money", tag: "money" },
  { id: 2, name: "Health", tag: "health" },
  { id: 3, name: "Prosperity", tag: "prosperity" },
  { id: 4, name: "Relationship", tag: "relationship" },
  { id: 5, name: "Evil Eye", tag: "evil eye" },
] as const;

export const FREE_RUDRAKSHA_PRODUCT = {
  id: "FREE_RUDRAKSHA_5_MUKHI",
  name: "5 Mukhi Rudraksha",
  slug: "free-5-mukhi-rudraksha",
  price: 0,
  compare_at_price: 499,
  image_url: "https://tfu-media.s3.ap-south-1.amazonaws.com/files/1761342229274-rudraksha.png",
  benefits: ["Peace", "Clarity"],
  productCategoryId: "rudraksha-category-id",
  rating: 5,
  review_count: 999,
  metaData: {},
};
